// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"SendResultsByEmail_iconSync__2wL05","fa-spin":"SendResultsByEmail_fa-spin__EreZn","accordionHeader":"SendResultsByEmail_accordionHeader__DAHQX"};